<template>
  <div class="content">
    <div class="content-item">
      <img :src="img" >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    height: String,
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.content-item {
  overflow: hidden;
}
.content-item img {
  width: 1920px;
  position: relative;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 1199px) and (min-width: 992px){
  .content-item img {
    width: calc(1920px * 0.8);
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .content-item img {
    width: calc(1920px * 0.6);
  }
}
@media screen and (max-width: 767px){
  .content-item img {
    width: calc(1920px * 0.5);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/solution/detailImg.vue